import React, { useState, useEffect, forwardRef,useRef,useMemo,useCallback } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import { Modal } from "@appkit4/react-components/modal";
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import { Select } from "@appkit4/react-components/select";
import { Switch } from "@appkit4/react-components/switch";
import { Formik } from "formik";
import { handleNotificationSubmit } from "../../Plan/notification/notification.js";
import * as Yup from "yup";
import displayToastMessage from "../../../../src/components/Common/Alert/displayToastMessage";
import * as XLSX from "@e965/xlsx";
import PropTypes from "prop-types";
import NewDateString from "../../Common/newDateString.js";
import APIService from "../../../services/apiAxiosService.js";
import useHttp from "../../../hooks/useHttp.js";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic

export default function CreateWorkProgram(props) {
  
  
  useEffect(() => {
    getAllVendorListData();
    getWorkPrograms();
  }, []);

  useEffect(() => {
    if (props.WPRequestData) {
      getWPEditDetails(props.WPRequestData);
    }
  }, [props.WPRequestData])

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [workProgramName, setWorkProgramName] = useState([]);
  const [wpDetails, setWPDetails] = useState([]);
  const [wpEditDetails, setWPEditDetails] = useState([]);
  const { sendRequest: getAllControlWorkProgramAPI } = useHttp();
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: getWorkProgramDetailsById } = useHttp();
  const { sendRequest: createWorkProgram } = useHttp();
  const { sendRequest: addFile } = useHttp();
  const { sendRequest: getAllFiles } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: selectWorkPrograms } = useHttp();
  const [submitLoader, setSubmitLoader] = useState(false);
  const [initialValues, setInitialValues] = useState({
    vendorName: props.selectedVendor,
    workProgramName: "",
    instructions: "",
    validityFrom: "",
    validityTo: "",
  });
  const [gridApi, setGridApi] = useState(null);

  // Apply settings across all columns
  const defaultColDef = useMemo(() => ({
   // Enable filtering on all columns,
   // flex:1,
   sortable: true,
   cellDataType: false,
   wrapText: true,     
   autoHeight: true,  
 }));

 const onGridReady = (params) => {
   setGridApi(params.api);
 };

 

const onCellValueChanged = ((event) => {
  var data = event.data;
  const dataUpdate = [...tableData];
  const index = event.rowIndex;
  dataUpdate[index] = data;
  setTableData([...dataUpdate]);
});





  const getAllVendorListData = async () => {
    getAllVendorList(APIService.getAllVendorList(), (data) => {
      setVendors(data.MSG);
    });
  };
  const getWorkPrograms = async () => {
    await getAllControlWorkProgramAPI(
      APIService.getAllControlWorkProgram(),
      (data) => setWorkProgramName(data.MSG)
    );
  };

  let visibleToggle = (rowData, type) => {
    let keys = Object.keys(rowData);

    if (type === "Domain") {
      return !!(keys.includes("Domain") && keys.includes("Sub Domain"));
    } else if (type === "subDomain") {
      return !!(keys.includes("Sub Domain"));
    } else if (type === "area") {
      return !!(keys.includes("Area") && keys.includes("Sub Area"));
    } else if (type === "subArea") {
      return !!(keys.includes("Sub Area"));
    }
  };

  let handleCheckFieldValue = (rowData, type, value) => {
    let rowId = rowData?.node?.rowIndex;
    let UpdatedTableDta = [...tableData];

    if (type === "domain") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Domain") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].domainToggle = value;
          UpdatedTableDta[i].subDomainToggle = value;
          UpdatedTableDta[i].controlIDToggle = value;
        }
      }
    } else if (type === "subDomain") {
      let i;
      //CHECKING FOR PARENT ON STATE(IF PARENT FALSE CHILD CAN NOT BE TRUE)
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].domainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              for (i = rowId; i < tableData.length; i++) {
                let keys = Object.keys(tableData[i]);
                if (keys.includes("Sub Domain") && !(i === rowId)) {
                  break;
                } else {
                  UpdatedTableDta[i].subDomainToggle = value;
                  UpdatedTableDta[i].controlIDToggle = value;
                  //     if(keys.includes("Sub Domain") ){//
                  //         UpdatedTableDta[i].subDomainToggle = value;
                  //         UpdatedTableDta[i].controlIDToggle = true;
                  //     }
                  //    else{UpdatedTableDta[i].controlIDToggle = false;}
                }
              }
            }
            break;
          }
        }
      } else {
        for (i = rowId; i < tableData.length; i++) {
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain") && !(i === rowId)) {
            break;
          } else {
            UpdatedTableDta[i].subDomainToggle = value;
            UpdatedTableDta[i].controlIDToggle = value;
          }
        }
      }
    } else if (type === "controlID") {
      let i;
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          //LOOPS BACK FOR IT's PARENTS.
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].subDomainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              UpdatedTableDta[rowId].controlIDToggle = value;
            }
            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
        }
      } else {
        let allChildStatus = false;

        let startIndex;
        for (let j = rowId; j >= 0; j--) {
          let keys = Object.keys(tableData[j]);
          if (keys.includes("Sub Domain")) {
            startIndex = j;
            break;
          }
        }
        let endIndex;
        for (let k = startIndex + 1; k < tableData.length; k++) {
          let keys = Object.keys(tableData[k]);
          if (keys.includes("Sub Domain")) {
            endIndex = k - 1;
            break;
          } else {
            endIndex = k;
          }
        }
        //WITH START AND END INDEX SEARCH FOR TRUE AND FALSE OF CONTROL ID, IF ALL DOMAINS ARE FALSE THEN SUB-DOMAINS WILL BE FALSE.
        for (let l = startIndex; l <= endIndex; l++) {
          if (l !== rowId && UpdatedTableDta[l].controlIDToggle === true) {
            allChildStatus = true;
            break;
          }
        }
        if (allChildStatus) {
          for (let l = startIndex; l <= endIndex; l++) {
            let keys = Object.keys(tableData[l]);
            if (keys.includes("Sub Domain")) {
              UpdatedTableDta[l].subDomainToggle = true;
            } else {
              UpdatedTableDta[l].subDomainToggle = true;
            }
          }
        } else {
          for (let l = startIndex; l <= endIndex; l++) {
            UpdatedTableDta[l].subDomainToggle = false;
          }
        }

        UpdatedTableDta[rowId].controlIDToggle = value; //THE SELECTED WILL BE FALSE
      }
    } else if (type === "area") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Area") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].areaToggle = value;
          UpdatedTableDta[i].subAreaToggle = value;
          UpdatedTableDta[i].questionIDToggle = value;
        }
      }
    } else if (type === "subArea") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Sub Area") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].subAreaToggle = value;
          UpdatedTableDta[i].questionIDToggle = value;
        }
      }
    } else if (type === "questionID") {
      // UpdatedTableDta[rowId].questionIDToggle = value;
      let i;
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          //LOOPS BACK FOR IT's PARENTS.
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].subDomainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              UpdatedTableDta[rowId].controlIDToggle = value;
            }
            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
          if (keys.includes("Question Id")) {
            //CHECKING FOR PARENT
            //CHECKING FOR PARENT STATE(ON/OFF)
            UpdatedTableDta[rowId].questionIDToggle = value;

            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
        }
      } else {
        let allChildStatus = false;

        let startIndex;
        for (let j = rowId; j >= 0; j--) {
          let keys = Object.keys(tableData[j]);
          if (keys.includes("Sub Area")) {
            startIndex = j;
            break;
          }
        }
        let endIndex;
        for (let k = startIndex; k < tableData.length; k++) {
          let keys = Object.keys(tableData[k]);
          if (k != startIndex && keys.includes("Sub Area")) {
            endIndex = k;
            break;
          } else {
            endIndex = k;
          }
        }
        //WITH START AND END INDEX SEARCH FOR TRUE AND FALSE OF CONTROL ID, IF ALL DOMAINS ARE FALSE THEN SUB-DOMAINS WILL BE FALSE.
        for (let l = startIndex; l <= endIndex; l++) {
          if (l !== rowId && UpdatedTableDta[l].questionIDToggle === true) {
            allChildStatus = true;
            break;
          }
        }
        if (allChildStatus) {
          for (let l = startIndex; l <= endIndex; l++) {
            let keys = Object.keys(tableData[l]);
            if (keys.includes("Sub Area")) {
              UpdatedTableDta[l].subAreaToggle = true;
            } else {
              UpdatedTableDta[l].subAreaToggle = true;
            }
          }
        } else {
          for (let l = startIndex; l <= endIndex; l++) {
            UpdatedTableDta[l].subAreaToggle = false;
          }
        }

        UpdatedTableDta[rowId].questionIDToggle = value; //THE SELECTED WILL BE FALSE
      }
    }
    setTableData(UpdatedTableDta);
  };

  const getFilesNames = async (selected) => {
    let type = "";
    setSelectedType(selected);
    if (selected === 1) {
      setTableData([]);
      type = "domain";
    } else {
      setTableData([]);
      type = "questionnaire";
    }
    getAllFiles(
      APIService.getAllFiles(type),
      responseHandlerFiles,
      errorHandler
    );
  };

  const responseHandlerFiles = (result) => {
    if (result.CODE) {
      setSelectedFiles(result.MSG);
    }
  };

  const errorHandler = () => {
    let MSG = "Something went wrong, Please try again!";
    displayToastMessage(MSG, "error");
  };

  const handleSubmit = async (values) => {
    setSubmitLoader(true);
    if (props.WPRequestData) {
      let jsonArray = [];
      let data = {
        email:sessionStorage.getItem("email"),
        flag: "update",
        paramWorkProgramStatus: "Approved",
        paramUserID: Number(sessionStorage.getItem("userId")),
        paramWorkProgram: values.workProgramName,
        paramInstructions: values.instructions,
        paramWorkProgramOwner: wpDetails?.workprogram_owner,
        paramValidFrom: new Date(values.validityTo),
        paramValidTo: new Date(values.validityFrom),
        paramCategoryData: JSON.stringify(tableData),
        paramVendorId: values.vendorName,
        paramVendorAssessmentRequestID: props.assessmentRequestId,
        paramWorkProgramID: Number(props.WPRequestData),
      };

      jsonArray.push(data);
      createWorkProgram(
        APIService.createWorkProgram(jsonArray),
        (result) => {
          if (result.CODE) {
            displayToastMessage("Work Program updated successfully", "success");
            let notifData = {
              paramuserid: Number(sessionStorage.getItem("userId")),
              paramreqid: Number(values.vendorName),
              paramcontent: "updated work program",
              paramnextroleid: 2,
              paramcreatedby: Number(sessionStorage.getItem("roleId")),
              parammsgtype: result.MSG,
            };
            handleNotificationSubmitAPI(
              APIService.handleNotificationSubmit(notifData),
              () => {}
            );
            props.sendBack();
          }
        },
        errorHandler
      );
    } else {
      let jsonArray = [];
      let data = {
        email:sessionStorage.getItem("email"),
        flag: "create",
        paramWorkProgramStatus: "Approved",
        paramUserID: Number(sessionStorage.getItem("userId")),
        paramWorkProgram: values.workProgramName,
        paramInstructions: values.instructions,
        paramWorkProgramOwner: wpDetails?.workprogram_owner,
        paramValidFrom: new Date(values.validityTo),
        paramValidTo: new Date(values.validityFrom),
        paramCategoryData: JSON.stringify(tableData),
        paramVendorId: values.vendorName,
        paramVendorAssessmentRequestID: props.assessmentRequestId,
      };
      jsonArray.push(data);
      createWorkProgram(
        APIService.createWorkProgram(jsonArray),
        (result) => {
          if (result.CODE) {
            displayToastMessage(result.MSG, "success");
            let notifData = {
              paramuserid: Number(sessionStorage.getItem("userId")),
              paramreqid: Number(values.vendorName),
              paramcontent: "created work program",
              paramnextroleid: 2,
              paramcreatedby: Number(sessionStorage.getItem("roleId")),
              parammsgtype: result.MSG,
            };
            handleNotificationSubmitAPI(
              APIService.handleNotificationSubmit(notifData),
              () => {}
            );
            props.sendBack();
          }
        },
        errorHandler
      );
    }
    setSubmitLoader(false);
  };

  const validationSchema = Yup.object().shape({
    vendorName: Yup.string()
      .required("Third party name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    workProgramName: Yup.string()
      .required("Work program name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    instructions: Yup.string()
      .required("Instructions (if any) is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    validityFrom: Yup.string().required("Validity from is required"),
    validityTo: Yup.string().required("Validity to is required"),
  });
  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleConfirm = () => {
    let msg = "Request has been created successfully";
    displayToastMessage(msg, "success");
    setModalVisible(false);
    props.sendBack();
  };

 

  

  const responseHandler = (result) => {
    if (result.CODE) {
      displayToastMessage(result.MSG, "success");
      getFilesNames();
    }
  };


  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const getWPDetailsResponse = (result, e) => {
    if (result.CODE) {
      setWPDetails(result.MSG[0]);
      let prev = { ...initialValues };
      let res = result.MSG[0];
      prev.vendorName = props.selectedVendor;
      prev.instructions = res.instructions;
      prev.validityTo = formatDate(res.validfrom);
      prev.validityFrom = formatDate(res.validtill);
      prev.workProgramName = e;
      setInitialValues(prev);

      let tableData = JSON.parse(result.MSG[0].category_data);
      setTableData(tableData);
      setSelectedType(result.MSG[0].workprogramcategory);
    }
  };

  const getWPDetails = async (e) => {
    getWorkProgramDetailsById(
      APIService.getWorkProgramDetailsById(e, props.assessmentRequestId),
      (res) => getWPDetailsResponse(res, e)
    );
  };

  const responseHandlerWP = (result) => {
    if (result.MSG) {
      setWPEditDetails(result.MSG[0]);
      let prev = { ...initialValues };
      let res = result.MSG[0];
      prev.vendorName = props.selectedVendor;
      prev.instructions = res.instructions;
      prev.validityTo = formatDate(res.validfrom);
      prev.validityFrom = formatDate(res.validtill);
      prev.workProgramName = Number(res.workprogramname);
      setInitialValues(prev);

      let tableData = JSON.parse(result.MSG[0].category_data);

      setTableData(tableData);
      setSelectedType(result.MSG[0].workprogramcategory);
    }
  }
 
  const getWPEditDetails = async (e) => {
    selectWorkPrograms(APIService.selectWorkPrograms(e, props.assessmentRequestId), responseHandlerWP)
  };

  const rowStyle = { background: 'white' };


  return (
    <div className="App">
         {props.loader ? (
            <div className="row" id="preloader">
              <div className="col-12 col-lg-12 loader-margin text-center">
                <div className="a-loading a-primary a-m-10" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            <div>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {(prop) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit
          } = prop;

          return (
            <form onSubmit={handleSubmit}>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <div className="cv-input-field-container-disabled pt-0 pb-0">
                    <label className="cv-input-label">
                      Third Party Name <span className="asterisk-required">*</span>
                    </label>
                    <Select
                      showSearchOnToggle={true}
                      dropdownRenderMode="portal"
                      className="cv-input-field"
                      data={props.vendors}
                      valueKey="vendor_id"
                      labelKey="vendor_name"
                      value={values.vendorName}
                      onSelect={(e) =>
                        handleChange("vendorName")({ target: { value: e } })
                      }
                      name="Third Party Name"
                      placeholder="Select Third Party Name"
                      disabled
                    ></Select>
                  </div>
                  {errors.vendorName && touched.vendorName && (
                    <div className="form-label error">{errors.vendorName}</div>
                  )}
                </div>
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label className="cv-input-label">
                      Work Program Name <span className="asterisk-required">*</span>
                    </label>
                    <Select
                      showSearchOnToggle={true}
                      dropdownRenderMode="portal"
                      className="cv-input-field"
                      data={workProgramName}
                      valueKey="workprogram_id"
                      labelKey="work_program_name"
                      value={Number(values.workProgramName)}
                      onSelect={(e) => {
                        handleChange("workProgramName")({
                          target: { value: e },
                        });
                        getWPDetails(e);
                      }}
                      name="Third Party Name"
                      placeholder="Select work program Name"
                    ></Select>
                  </div>
                  {errors.workProgramName && touched.workProgramName && (
                    <div className="form-label error">
                      {errors.workProgramName}
                    </div>
                  )}
                </div>
              </div>
              <div className="row ">
                <div className="col-sm-6">
                  <div className="cv-input-field-container">
                    <label htmlFor="validityDefine" className="cv-input-label">
                      Validity From <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field p-l-13"
                      type="date"
                      id="validityDefine"
                      name="LastAssessmentDate"
                      onBlur={handleBlur}
                      value={values.validityTo}
                      min={NewDateString()}
                      onChange={handleChange("validityTo")}
                    />
                  </div>
                  {errors.validityTo && touched.validityTo && (
                    <div className="form-label error">{errors.validityTo}</div>
                  )}
                </div>

                <div className="col-sm-6">
                  <div className="cv-input-field-container">
                    <label htmlFor="toDefine" className="cv-input-label">
                      Validity To <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field leftPadding"
                      type="date"
                      id="toDefine"
                      name="validity From"
                      onBlur={handleBlur}
                      value={values.validityFrom}
                      min={NewDateString(values.validityTo)}
                      onChange={handleChange("validityFrom")}
                    />
                  </div>
                  {errors.validityFrom && touched.validityFrom && (
                    <div className="form-label error">
                      {errors.validityFrom}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label htmlFor="instructionsDefine" className="cv-input-label">
                      Instructions (if any){" "}
                      <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field p-l-14"
                      onBlur={handleBlur}
                      id="instructionsDefine"
                      type="text"
                      value={values.instructions}
                      onChange={handleChange("instructions")}
                      name="Instructions"
                      placeholder={"Please Add Instructions"}
                    />
                  </div>
                  {errors.instructions && touched.instructions && (
                    <div className="form-label error">
                      {errors.instructions}
                    </div>
                  )}
                </div>
                <div className="col-sm-6">
                  <div className="cv-input-field-container-disabled">
                    <label className="cv-input-label">
                      Manager Comments
                      <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field-disabled"
                      type="text"
                      value={
                        wpEditDetails.managercomments !== null
                          ? wpEditDetails.managercomments
                          : ""
                      }
                      name="comments"
                      placeholder="No comments to show"
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div className="row pt-5 pl-3">
                <div className="col-lg-12 mt-3 pl-1">
                  <div className="row p-1">
                    <div className="col-md-12">
                    <div class="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                          <AgGridReact
                            rowData={tableData}
                            rowStyle={rowStyle}

                            columnDefs={selectedType==1 ?
                              [
                                {
                                  headerName: "Select",
                                  field: "Select",
                                  cellRenderer: (rowData) =>
                                  visibleToggle(rowData.data, "Domain") && (
                                    <Switch
                                      checked={rowData.data.domainToggle}
                                      onChange={(e) =>
                                        handleCheckFieldValue(
                                          rowData,
                                          "domain",
                                          e
                                        )
                                      }
                                    ></Switch>
                                  ),
                                }, {
                                  headerName: "S.No",
                                  field: "SNo",
                                }, {
                                  headerName: "Domain",
                                  field: "Domain",
                                  editable:true,
                                }, {
                                  headerName: "Select",
                                  field: "Select",
                                  cellRenderer: (rowData) =>
                                  visibleToggle(rowData.data, "subDomain") && (
                                    <Switch
                                      checked={rowData.data.subDomainToggle}
                                      onChange={(e) =>
                                        handleCheckFieldValue(
                                          rowData,
                                          "subDomain",
                                          e
                                        )
                                      }
                                    ></Switch>
                                  ),
                                },{
                                  headerName: "S.No",
                                  field: "S.No Sub Domain",
                                  
                                },{
                                  headerName: "Sub Domain",
                                  field: "Sub Domain",
                                  editable:true,

                                 
                                },
                                { headerName: "Select", field: "Select", cellRenderer: (rowData) => (
                                  <Switch
                                    checked={rowData.data.controlIDToggle}
                                    onChange={(e) =>
                                      handleCheckFieldValue(
                                        rowData,
                                        "controlID",
                                        e
                                      )
                                    }
                                  ></Switch>
                                ), },
                                
                                {
                                  headerName: "Control ID",
                                  field: "Control ID",
                                  editable:true,

                                 
                                }, {
                                  headerName: "Control Definition",
                                  field: "Control Definition",
                                  editable:true,

                                 
                                }, {
                                  headerName: "Control Testing Procedure",
                                  field: "Control Testing Procedure",
                                  editable:true,

                                 
                                },{
                                  headerName: "Attachment required",
                                  field: "Attachment required",
                                  editable:true,

                                 
                                },{
                                  headerName: "Attachment Type",
                                  field: "Attachment Type",
                                  editable:true,

                                },]:[
                              {
                                headerName: "Select",
                                field: "Select",
                                editable: false,
                                cellDataType:'boolean',
                                 width:"80",
                                cellRenderer: (rowData) =>
                                visibleToggle(rowData.data, "area") && (
                                  <Switch
                                    checked={rowData.data.areaToggle}
                                    onChange={(e) =>
                                      handleCheckFieldValue(
                                        rowData,
                                        "area",
                                        e
                                      )
                                    }
                                  ></Switch>
                                ),
                              },
                              { headerName: "S.No", field: "SNo",  width:"80",},
                              { headerName: "Area", field: "Area", editable: false },
                              { headerName: "Select",field: "Select",  width:"80",editable: false, cellRenderer: (rowData) =>
                              visibleToggle(rowData.data, "subArea") && (
                                <Switch
                                  checked={rowData.data.subAreaToggle}
                                  onChange={(e) =>
                                    handleCheckFieldValue(
                                      rowData,
                                      "subArea",
                                      e
                                    )
                                  }
                                ></Switch>
                              ),},
                              { headerName: "Sub Area",field: "Sub Area",editable: false, width:"100"},
                              { headerName: "Select", field: "Select",editable: false, width:"100", cellRenderer: (rowData) => (
                                <Switch
                                  checked={rowData.data.questionIDToggle}
                                  onChange={(e) =>
                                    handleCheckFieldValue(
                                      rowData,
                                      "questionID",
                                      e
                                    )
                                  }
                                ></Switch>
                              ),
                              },
                              { headerName: "Question Id", width:"120", field: "Question Id",editable: false },
                                                          { headerName: "Question", width:"1200", field: "Question",editable: false,cellEditor: "agLargeTextCellEditor",cellEditorPopup: true ,cellEditorParams: {
                                                            maxLength: 500
                                                        },},
                                                          {
                                                            headerName: "Instructions (If any)",
                                                            field: "Instructions (If any)",
                                                            editable: false,width:400,cellEditor: "agLargeTextCellEditor",cellEditorPopup: true,cellEditorParams: {
                                                              maxLength: 500
                                                          },
                                                          },
                                                          {
                                                            headerName: "Attachment required",
                                                            field: "Attachment required",
                                                            editable: false
                                                          },
                                                          {
                                                            headerName: "Attachment Type",
                                                            field: "Attachment Type",
                                                            editable: false
                                                          },
                             
                              
                            ]}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            onCellValueChanged={onCellValueChanged}
                            onGridReady={onGridReady}
                          />
                        </div>
                    </div>
                  </div>
                </div>

                <div className="options-container">
                  {submitLoader ? (
                    <button
                      className="btn btn-secondary loading-btn mr-2"
                      type="button"
                      disabled
                    >
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="pl-1">Loading...</span>
                    </button>
                  ) : props.edit ? (
                    props.WPRequestData ? (
                      <button type="submit" className="save-button mt-4 me-4">
                        Update
                      </button>
                    ) : (
                      <button type="submit" className="save-button mt-4 me-4">
                        Submit
                      </button>
                    )
                  ) : (
                    ""
                  )}

                  <button
                    className="cancel-button mt-4 me-3"
                    type="reset"
                    onClick={props.sendBack}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
</div>)}
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
          <div className="modal-title">
            Are you sure you want to submit the Request?
          </div>
          <ModalFooter>
            <div className="modal-footer">
              <button
                type="button"
                className="cancel-button"
                onClick={handleCancel}
              >
                No
              </button>
              <button
                type="submit"
                className="save-button m-l-2"
                onClick={handleConfirm}
              >
                Yes
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

CreateWorkProgram.propTypes = {
  WPRequestData: PropTypes.any,
  selectedVendor: PropTypes.any,
  assessmentRequestId: PropTypes.any,
  sendBack: PropTypes.any,
  vendors: PropTypes.any
}
